"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDepGraph = void 0;
const legacy_1 = require("@snyk/dep-graph/dist/legacy");
function buildDepGraph(partialDepTree, projectName) {
    const packageToDepTreeMap = new Map();
    const queue = [partialDepTree.dependencies];
    const referencesToUpdate = [];
    while (queue.length > 0) {
        const dependencies = queue.pop();
        if (!dependencies)
            continue;
        for (const [key, dependencyDepTree] of Object.entries(dependencies)) {
            if (dependencyDepTree === 'true') {
                referencesToUpdate.push({ key, dependencies });
            }
            else {
                packageToDepTreeMap.set(key, dependencyDepTree);
                queue.push(dependencyDepTree.dependencies);
            }
        }
    }
    referencesToUpdate.forEach(({ key, dependencies }) => {
        if (!packageToDepTreeMap.get(key)) {
            // this should never happen
            throw new Error(`key ${key} not found in packageToDepTreeMap`);
        }
        dependencies[key] = packageToDepTreeMap.get(key);
    });
    if (projectName)
        partialDepTree.name = projectName;
    return (0, legacy_1.depTreeToGraph)(partialDepTree, 'pip');
}
exports.buildDepGraph = buildDepGraph;
//# sourceMappingURL=build-dep-graph.js.map